const inWeChat = (typeof wx !== 'undefined') && !window;
const version = '0.0.2',
      devApi = 'http://test2.rd.izhaowo.com:60055',
      relApi = 'https://tj.izhaowo.com';

const postInWeb = ({url, params}) => {
  var axios = require('axios');
  var post = axios.create({
    withCredentials: false,
    headers: {
      post: {
        /*'track-version': version,*/
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      'X-Requested-With': 'XMLHttpRequest'
    },
  });

  return post({
    method: 'post',
    url,
    params,
  });
};


const postInWeChat = ({url, params}) => {
  return new Promise((resolve, reject) => {
    wx.request({
      url: url,
      data: params || {},
      header: {
        /*'track-version': version,*/
        'content-type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      success: (res) => {
        if(!res || res.statusCode !== 200 || !res.data){
          throw new Error(res);
        }
        resolve(res.data);
      },
      fail: function (res) {
        console.log(`网络请求失败: ${url}: ${JSON.stringify(res)}`);
        reject(res);
      },
    });
  });
};


const post = ({url, params}) => {
  if(inWeChat) return postInWeChat({url, params});
  return postInWeb({url, params});
};


const Logger = function({ api }){
  const _api_ = api;
  let clientWidth = 0, clientHeight = 0;

  //获取屏幕尺寸
  if(inWeChat){
    wx.getSystemInfoSync({
      success: (res) => {
          clientWidth = res.screenWidth;
          clientHeight = res.screenHeight;
      }
    });
  }else{
      clientWidth = window.screen.width;
      clientHeight = window.screen.height;
  }

  /**
   * 统计案例点击，evt点击事件， caseId必传，登录后传userId
   *
   * */
  this.logTapCase = ({ evt, caseId = '', userId = '' }) => {
    var x = evt && (evt.clientX || evt.detail && evt.detail.x) || 0,
        y = evt && (evt.clientY || evt.detail && evt.detail.y) || 0;
    const scrollTop = !inWeChat && document.documentElement.scrollTop || 0;
    y += scrollTop;

    const refer = inWeChat && getCurrentPages()[0].route || window.location.href;
    let terminal = inWeChat && 'wechat' || '';
    if(!inWeChat){
      const ua = navigator.userAgent.toLocaleLowerCase();
      if(ua.indexOf('iphone') > -1){
        terminal = 'h5';
      }else if(ua.indexOf('android') > -1){
        terminal = 'h5';
      }else {
        terminal = 'web';
      }
    }

    const params = {
      caseId: caseId,
      time: new Date().getTime(),
      userId: userId,
      terminal: terminal,
      referer: refer,
      block: `x${x}y${y}`,
      screen: `w${clientWidth}h${clientHeight}`,
    };

    post({
      url: `${_api_}/v1/collectCaseLog`,
      params,
    });
  };

};



const exports = {
  useDev: function () {
    return new Logger({api: devApi});
  },
  useRel: function () {
    return new Logger({api: relApi});
  }
};



if (typeof define === 'function' && (define.amd || define.cmd)){
  module.exports = exports
}
export default exports;

// ;(function(){
//   var moduleName = exports;
//   // if (typeof module !== 'undefined' && typeof exports === 'object') {
//   //   module.exports = moduleName;
//   // } else
//     if (typeof define === 'function' && (define.amd || define.cmd)) {
//     define(function() { return moduleName; });
//   } else {
//     this.moduleName = moduleName;
//   }
// }).call(function() {
//   return this || (typeof window !== 'undefined' ? window : global);
// });



// WEBPACK FOOTER //
// ./src/plugin/logger.js